<template>
    <div class="animated fadeIn">
        <div
            class="app-contentHeader"
            :class="{ 'kgr-hidden-print': printViewHideButtons }"
        >
            <div v-if="!withBackButton"></div>
            <a
                v-else
                class="kgr-button kgr-button--link"
                @click="onBack"
            >
                <kgr-icon
                    icon-class="arrow-left"
                    class="kgr-button__icon kgr-button__icon--left kgr-icon"
                />

                <span v-t="'backToOverview'"></span>
            </a>

            <div v-if="withPrimaryButtons">
                <slot name="additionalButtons"></slot>
                <kgr-button
                    v-if="withSaveButton"
                    :value="saveButtonValue"
                    type="blue"
                    :pending="pending"
                    :disabled="saveButtonDisabled"
                    @click="onCreate"
                />
            </div>
        </div>

        <div class="kgr-row">
            <slot></slot>
        </div>

        <div
            class="app-formFooter"
            :class="{ 'kgr-hidden-print': printViewHideButtons }"
        >
            <div v-if="hideMandatoryFieldsHint" class="app-formFooter__hint">
&nbsp;
            </div>
            <div
                v-else-if="(editMode || withPrimaryButtons)"
                v-t="'Felder mit * sind Pflichtfelder'"
                class="app-formFooter__hint"
            >
            </div>
            <div
                v-if="withPrimaryButtons"
                class="app-formFooter__actions"
            >
                <div class="app-formFooter__action">
                    <kgr-print-button v-if="withPrintButton" />
                    <kgr-button
                        v-if="editMode && withDeleteButton"
                        :value="$t('delete')"
                        type="red"
                        class="delete"
                        :pending="pendingDelete"
                        @click="onDelete"
                    />
                    <slot name="additional-footer-button"></slot>
                    <kgr-button
                        v-if="withBackButton"
                        :value="$t('cancel')"
                        type="grey"
                        @click="onBack"
                    />
                </div>
                <div class="app-formFooter__action">
                    <slot name="additional-buttons"></slot>
                    <kgr-button
                        v-if="withSaveButton"
                        :value="saveButtonValue"
                        type="blue"
                        :pending="pending"
                        :disabled="saveButtonDisabled"
                        @click="onCreate"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '../icon/Icon.vue';
import KgrButton from './button/KgrButton';
import PrintButton from './button/PrintButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-print-button': PrintButton,
        'kgr-icon': Icon,
    },
    props: {
        pending: {
            type: Boolean,
            required: false,
        },
        pendingDelete: {
            type: Boolean,
            required: false,
        },
        editMode: {
            type: Boolean,
            required: false,
        },
        withBackButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        withDeleteButton: {
            type: Boolean,
            required: false,
        },
        withPrintButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        printViewHideButtons: {
            type: Boolean,
            required: false,
            default: false,
        },
        saveButtonDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        saveButtonLabel: {
            type: String,
            required: false,
            default: null,
        },
        withPrimaryButtons: {
            type: Boolean,
            required: false,
            default: true,
        },
        withSaveButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        hideMandatoryFieldsHint: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        saveButtonValue() {
            if (this.saveButtonLabel != null) {
                return this.saveButtonLabel;
            }
            return this.editMode ? this.$t('saveChanges') : this.$t('save');
        },
    },
    methods: {
        onCreate() {
            this.$emit('primaryBtnClicked');
        },
        onBack() {
            this.$emit('backBtnClicked');
        },
        onDelete() {
            this.$emit('deleteBtnClicked');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
